export default {
    estimate: {
        label: window.i18n.__('Devis'),
    },
    invoice: {
        label: window.i18n.__('Facture'),
    },
    order: {
        label: window.i18n.__('Bon de commande'),
    },
    proforma: {
        label: window.i18n.__('Proforma'),
    },
    delivery: {
        label: window.i18n.__('Bon de livraison'),
    },
    creditnote: {
        label: window.i18n.__('Avoir'),
    },
};
